// French connectors that should be skipped when auto-building initials.
const STOP_WORDS = new Set(['et', 'de', 'du', 'des', 'le', 'la', 'les']);

// Returns a short form of a client name.
//  - If a manual `abbr` is provided (column on clients table), it wins.
//  - Otherwise builds initials from words, skipping common French connectors
//    (et, de, du, des, le, la, les). Strips leading "l'" / "d'" elisions.
//  - If only one meaningful word remains, returns it as-is.
// Examples:
//   clientShort('Credit Agricole du Maroc')      -> 'CAM'
//   clientShort('Banque de la Marine')           -> 'BM'
//   clientShort('ONCF')                          -> 'ONCF'
//   clientShort('Attijariwafa Bank')             -> 'AB'
//   clientShort('L\'Office National')            -> 'ON'
//   clientShort('Anything', 'XYZ')               -> 'XYZ' (manual wins)
export function clientShort(name, abbr = null) {
  if (abbr && String(abbr).trim()) return String(abbr).trim();
  if (!name) return '';
  // Filter stop-words first (without stripping anything — we keep originals)
  const filtered = String(name).trim().split(/\s+/)
    .filter(w => w && !STOP_WORDS.has(w.toLowerCase()));
  if (filtered.length === 0) return '';
  // Single remaining word: return it as-is (e.g. "L'Oréal" stays "L'Oréal", "ONCF" stays "ONCF")
  if (filtered.length === 1) return filtered[0];
  // Multi-word: strip leading "l'" / "d'" elisions, then take first letter of each word
  return filtered.map(w => {
    const stripped = w.replace(/^[ldLD][''']/, '');
    return (stripped[0] || '').toUpperCase();
  }).join('');
}
